export default function AboutCreator() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#F8FAFB]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-widest text-[#2F7FB7] font-semibold mb-4">Meet the Creator</p>
          <h2 className="text-5xl font-serif text-[#2F7FB7] mb-6">About Hein Roth</h2>
          <p className="text-xl text-[#4A5568] max-w-3xl mx-auto">
            A highly accomplished Australian-registered psychologist with over 40 years of experience
          </p>
        </div>

        <div className="grid md:grid-cols-5 gap-12 items-start">
          {/* Left - Photo */}
          <div className="md:col-span-2">
            <div className="sticky top-8">
              <div className="relative group">
                <div className="absolute inset-0 bg-gradient-to-br from-[#2F7FB7] to-[#5A9FD4] rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition-opacity duration-500"></div>
                <div className="relative bg-white rounded-3xl p-4 shadow-2xl">
                  <div className="aspect-[3/4] bg-gradient-to-br from-[#E8F1F5] to-[#D1E3EA] rounded-2xl overflow-hidden flex items-center justify-center">
                    <img 
                      src="https://static.readdy.ai/image/60c09a59e0fb28552f21c009d5db8614/ac61143a5f0c9b0e5949df437a3e8c64.png"
                      alt="Hein Roth - Registered Psychologist"
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div className="mt-6 text-center">
                    <h3 className="text-2xl font-serif text-[#2F7FB7] font-semibold mb-2">Hein Roth</h3>
                    <p className="text-[#6B7280] text-sm mb-4">Australian-Registered Psychologist</p>
                    <div className="flex items-center justify-center gap-2 text-[#5A9FD4]">
                      <i className="ri-award-fill text-xl"></i>
                      <span className="text-sm font-medium">40+ Years Experience</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right - Biography */}
          <div className="md:col-span-3 space-y-6">
            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-[#D1E3EA]">
              <p className="text-[#4A5568] leading-relaxed mb-6">
                Following registration as a Counselling Psychologist in South Africa, Hein practiced in South Africa for 18 years, including several years in full-time service with the South African Medical Services during the South African Border War, which provided him with invaluable expertise in managing a wide range of trauma-related conditions. Hein also has vast experience in management, having served as Manager, Psychological Services for a large South African mining concern.
              </p>
              <p className="text-[#4A5568] leading-relaxed">
                In 2001, Hein relocated to New Zealand, where he continued his work as a registered psychologist in a consulting capacity. A significant aspect of his practice involved suicide identification and prevention within New Zealand's farming communities. Hein continues to be a registered Psychologist with the New Zealand Psychologists' Board.
              </p>
            </div>

            <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-[#D1E3EA]">
              <p className="text-[#4A5568] leading-relaxed mb-6">
                Following the 2010 devastating earthquake in Christchurch, Hein relocated to Perth, Western Australia in 2011, where he resumed practicing full-time as Principal Psychologist at The Trauma & Phobia Clinic. Hein is a registered psychologist with the Australian Health Practitioner Regulation Agency (AHPRA).
              </p>
              <p className="text-[#4A5568] leading-relaxed">
                Over the years, Hein has built an exceptional career specialising in psychological trauma, including PTSD, Complex PTSD, Burnout Syndrome, and a variety of Anxiety and Mood Disorders.
              </p>
            </div>

            <div className="bg-gradient-to-br from-[#2F7FB7] to-[#1E5A8E] rounded-3xl p-8 shadow-lg text-white">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 rounded-full bg-[#5A9FD4] flex items-center justify-center flex-shrink-0">
                  <i className="ri-heart-pulse-fill text-2xl text-white"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">Professional Approach</h4>
                  <p className="text-white/90 leading-relaxed">
                    Known for his warm, approachable, and professional demeanor, over the years, Hein has offered psychotherapeutic services both in person and remotely via video consultations, ensuring accessibility for individuals in remote communities, also internationally.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-gradient-to-br from-[#5A9FD4] to-[#2F7FB7] rounded-3xl p-8 shadow-lg text-white">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center flex-shrink-0">
                  <i className="ri-lightbulb-flash-fill text-2xl text-[#2F7FB7]"></i>
                </div>
                <div>
                  <h4 className="text-xl font-semibold mb-3">The Birth of RECOVER</h4>
                  <p className="text-white/95 leading-relaxed">
                    The ever-increasing need for mental health support eventually resulted in the development of RECOVER as a practical and evidence-based application designed to support subscribers in managing anxiety, lifting their mood, and nurturing their emotional wellbeing, utilising practical evidence-based strategies and tools shaped by Hein's 40+ years in private psychological practice.
                  </p>
                </div>
              </div>
            </div>

            {/* Credentials badges */}
            <div className="grid grid-cols-2 gap-4 mt-8">
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-[#D1E3EA] text-center">
                <i className="ri-map-pin-fill text-3xl text-[#2F7FB7] mb-3"></i>
                <p className="text-sm font-semibold text-[#2F7FB7]">Registered in Australia</p>
                <p className="text-xs text-[#6B7280] mt-1">Perth, Western Australia</p>
              </div>
              <div className="bg-white/80 backdrop-blur-sm rounded-2xl p-6 shadow-lg border border-[#D1E3EA] text-center">
                <i className="ri-global-fill text-3xl text-[#2F7FB7] mb-3"></i>
                <p className="text-sm font-semibold text-[#2F7FB7]">Registered in New Zealand</p>
                <p className="text-xs text-[#6B7280] mt-1">NZ Psychologists' Board</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
